import React from 'react'
import PropTypes from 'prop-types';
import {HtmlParse} from 'utils';
import Ingredients from '../Ingredients';
import Allergens from '../Allergens';
import Recipes from '../Recipes';
import EmotionalInformation from '../EmotionalInformation';
import TitleWithBar from 'components/TitleWithBar';

const Description = (props) => {
    const {product} = props;
    if (!product) return ''

    const description = product.description;
    const technical = props.technical;

    return (
        <div className="product-description">
            {description && <>
                <TitleWithBar title="Descripción" />
                <div className="product-description-content">
                    {HtmlParse(description)}
                </div>
            </>}
            {technical && <>
                <TitleWithBar title="Ficha Técnica" />
                <div className="product-description-content">
                    {HtmlParse(technical)}
                </div>
            </>}
            {product['Información Emocional'] && <EmotionalInformation product={product} />}
            {product['Ingredientes'] && <Ingredients product={product} />}
            {<Allergens product={product} />}
            {product['Receta'] && <Recipes product={product} />}
        </div>
    )
}

Description.propTypes = {
    description: PropTypes.string,
    technical: PropTypes.string,
    product: PropTypes.object,
}
export default Description;
